import './css/main.scss'

console.log('helloo world')
